import Head from "next/head";
import { organizationMicroData } from "./meta-utils";

function LocalBusinessMeta() {
  const microdata = organizationMicroData({
    address: {
      streetAddress: "6127 Shawson Dr",
      addressLocality: "Mississauga",
      addressRegion: "ON",
      postalCode: "L5T 1E4",
      addressCountry: "CA",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "43.6518425986345",
      longitude: "-79.65712818895702",
    },
  });

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(microdata) }}
      />
    </Head>

  );
}

export default LocalBusinessMeta;
